import { actions, mutations } from './layout.d';

export default {
  /**
   * Open Modal by Module
   */
  [actions.openModal]({ commit }, payload) {
    commit(mutations.updateModalStatus, {
      module: payload.module,
      status: true
    });
  },

  /**
   * Close Modal by Module
   */
  [actions.closeModal]({ commit }, payload) {
    commit(mutations.updateModalStatus, {
      module: payload.module,
      status: false
    });
  }
};
